import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Перевірка чи змінні оточення завантажені
if (!supabaseUrl || !supabaseKey) {
  console.error('❌ Supabase credentials not found!');
  console.error('REACT_APP_SUPABASE_URL:', supabaseUrl);
  console.error('REACT_APP_SUPABASE_ANON_KEY:', supabaseKey ? 'exists' : 'missing');
  console.error('⚠️ Please restart the development server: npm start');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

// Database schema:
// 
// Table: bookings
// - id (uuid, primary key)
// - doctor_name (text)
// - service_title (text)
// - patient_name (text)
// - patient_phone (text)
// - patient_email (text)
// - booking_date (date)
// - booking_time (text)
// - status (text) - 'pending', 'confirmed', 'cancelled'
// - created_at (timestamp)
//
// Table: blocked_slots
// - id (uuid, primary key)
// - doctor_name (text)
// - blocked_date (date)
// - blocked_time (text)
// - created_at (timestamp)
